<template>
  <v-card>
    <v-card-title class="headline grey lighten-2">
      Payment Details
    </v-card-title>

    <v-card-text class="">
      <v-row>
        <v-col cols="12" md="6">
          <div class="position-relative">
            <label for>Payment mode </label>
            <select name id class="form-control">
              <option value="Cheque">Cheque</option>
              <option value="Cash">Cash</option>
            </select>
            <span class="drop-icon">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-menu-down theme--light position-absolute"
              ></i>
            </span>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <label for> Discount &#37;</label>
          <div class="d-flex">
            <div class="position-relative" style="width: 105px">
              <select name id class="form-control">
                <option value="">&#37;</option>
                <option value="">&#8377;</option>
              </select>
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="
                    v-icon
                    mdi mdi-menu-down
                    theme--light
                    position-absolute
                  "
                  style="top: 48%"
                ></i>
              </span>
            </div>
            <div class="w-100">
              <input type="text" class="form-control" placeholder="20" />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <label for="">Amount</label>
          <input type="text" class="form-control" placeholder="00" />
        </v-col>
        <v-col cols="12" md="6">
          <label for="">Transaction ID</label>
          <input type="text" class="form-control" placeholder="00" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <label for="">Remark</label>
          <v-textarea outlined rows="3"></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="$emit('close')">Cancel</v-btn>
      <v-btn color="success" @click="openSwal(item, true)">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import Swal from "sweetalert2";
export default {
  methods: {
    openSwal(item, valid) {
      Swal.fire({
        text: "Payment details saved successfully.",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {});
    },
  },
};
</script>